import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {

  public readonly isHidden = signal(false);

  constructor() { }
}
